import Accordion from "../UI/Accordion";
import VerticalGanttChartTransportationIcon from "../ganttChart/verticalGanttChart/VerticalGanttChartTransportationIcon"
import TimePicker from "../UI/input/TimePicker"
import { ReactComponent as CloseIcon } from "../../assets/icons/x_black.svg"
import { EmployeeTransport, TransportationType } from "../../types/ganttChart";
import labels from "../../utils/labels";

type TransportOption = {
  id: TransportationType;
  title: string;
};

const EmployeeTransportListItem = ({
  transport,
  options,
  onTypeChange,
  onStartChange,
  onEndChange,
  canDelete,
  onDelete
}: {
  transport: EmployeeTransport
  options: TransportOption[],
  onTypeChange: (newType: TransportationType) => void
  onStartChange: (newStart: string) => void
  onEndChange: (newEnd: string) => void
  canDelete: boolean
  onDelete: () => void
}) => {

  const displayOptionIndex = options.findIndex(
    (option) => option.id === transport.type
  );

  const transportIcon = (option: TransportOption, isSelected: boolean) => (
    <VerticalGanttChartTransportationIcon
      type={option.id}
      color={isSelected ? "var(--col-interaction-secondary)" : "var(--col-text-secondary)"} size={16}
    />
  )

  return (
    <div className="flex gap-[var(--spacing-md)] items-end">
      <Accordion
        onChange={(newOption: TransportOption) => onTypeChange(newOption.id)} // error
        options={options}
        variant="PRIMARY"
        defaultText={labels.chooseTransport}
        label={labels.transportType}
        classes="w-full"
        displayOption={displayOptionIndex}
        leadingElement={transportIcon}
        labelKey="title"
      />
      <div className="flex gap-[var(--spacing-sm)] w-full">
        <TimePicker
          id="transport-start-time"
          value={transport.timeWindow.transportStartTime}
          onTimeChange={(newStart) => onStartChange(newStart)}
          label={labels.startTimeTransport}
          classes="w-full"
        />
        <TimePicker
          id="transport-end-time"
          value={transport.timeWindow.transportEndTime}
          onTimeChange={(newEnd) => onEndChange(newEnd)}
          label={labels.endTimeTransport}
          classes="w-full"
        />
      </div>
      {canDelete &&
        <div className="h-[40px] flex items-center">
          <CloseIcon
            width={20}
            height={20}
            onClick={onDelete}
            className="cursor-pointer"
          />
        </div>
      }
    </div>
  )
}

export default EmployeeTransportListItem